/* =========================================================================
   Priskel — cart count sync
   -------------------------------------------------------------------------
   WHY THIS EXISTS
   Shiprocket Smart Cart intercepts add-to-cart and performs the /cart/add.js
   call itself. The Halo theme's header counter (<hdt-cart-count>) only ever
   updates in response to the theme's own internal `cartCount` event, which
   the app never fires. Result: the item is in the cart server-side, but the
   header still reads the number Liquid rendered at page load, until the
   shopper refreshes.

   This watches for any successful cart mutation (whoever makes it — theme,
   Shiprocket, or another app), re-reads /cart.js, and fires the theme's own
   event so the counter updates itself:

       assets/events.js  ->  ThemeEvents.cartCount = 'cart:count:update'
                             payload: { detail: { item_count } }

   Only that one event is dispatched. `cart:update` carries a much richer
   payload (resource, sourceId, cartData, actionAfterATC, sections) that the
   drawer handlers destructure, so faking it would throw inside the theme.
   Writing the number directly is kept as a fallback for the case where the
   custom element has not connected.

   It does NOT replace the "item added" feedback a shopper needs. That is
   Shiprocket's side cart, which is configured to open (addToCartBehavior =
   "open_side_cart") but currently does not. Fix that in the Shiprocket
   Smart Cart dashboard — this file only keeps the number honest.

   To remove: delete this file and its tag in snippets/scripts.liquid.
   ========================================================================= */
(function () {
  if (window.__pkCartSync) return;
  window.__pkCartSync = true;

  /* Mutations only. /cart.js and /cart.js?srsc=1 are reads and must not
     match, or we would loop: sync -> dispatch -> sync. */
  var MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  var timer = null;
  var last = null;

  var CART_COUNT = 'cart:count:update';   /* ThemeEvents.cartCount */

  function paint(count) {
    /* The theme's own way. <hdt-cart-count> listens for this on document and
       sets its textContent from detail.item_count. priskel-stack.js also
       listens for it and recalculates the Stack & Save bar. Neither of them
       re-dispatches, and /cart.js is a read, so there is no feedback loop.

       detail MUST go through the constructor. CustomEvent defines `detail`
       as a read-only accessor on its prototype, so `ev.detail = {...}`
       silently no-ops and the listener receives null. (events.js gets away
       with assigning this.detail only because its classes extend Event,
       which has no such accessor.) */
    document.dispatchEvent(new CustomEvent(CART_COUNT, {
      bubbles: false,
      detail: { item_count: count }
    }));

    /* Fallback, in case the custom element is not connected on this page. */
    var nodes = document.querySelectorAll('hdt-cart-count, [data-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      if (String(nodes[i].textContent).trim() !== String(count)) {
        nodes[i].textContent = count;
      }
    }
  }

  function sync() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          if (last !== cart.item_count) paint(cart.item_count);
          last = cart.item_count;
        })
        .catch(function () {});
    }, 300);
  }

  /* --- catch the mutation, whoever performs it -------------------------- */

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (MUTATION.test(url)) {
        p.then(function (r) { if (r && r.ok) sync(); }).catch(function () {});
      }
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__pkCartMutation = MUTATION.test(String(url || '')); } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__pkCartMutation) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) sync();
      });
    }
    return origSend.apply(this, arguments);
  };

  /* --- safety net ------------------------------------------------------- */
  /* If an app captured a reference to fetch before this file ran, the
     wrapper above will not see its call. A couple of cheap reads after any
     add-to-cart click cover that case. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[name="add"], form[action*="/cart/add"] [type="submit"], [data-pk-add]')) return;
    setTimeout(sync, 900);
    setTimeout(sync, 2400);
  }, true);

  /* Back/forward cache and tab re-focus both serve a stale header. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });

  sync();
})();
